import {cn} from '@/lib/utils';
import {PropsWithChildren} from 'react';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  label: string;
  className?: string;
  childrenContainerClassName?: string;
} & PropsWithChildren;

export default function Accordion({
  isOpen,
  toggle,
  label,
  className,
  childrenContainerClassName,
  children,
}: Props) {
  return (
    <>
      <a
        onClick={toggle}
        className={cn(
          'cursor-pointer relative text-xl before:absolute before:left-0 before:text-blue before:top-[35%]  before:right-4 before:mt-[-0.5rem] leading-[1]',
          className,
          {
            "before:content-['-']": isOpen,
            "before:content-['+']": !isOpen,
          },
        )}>
        <span className="font-semibold ml-[20px] leading-[1.45]">{label}</span>
      </a>
      <div
        className={cn(
          'max-h-0 transition-[max-height] duration-[500ms] ease-in-out',
          childrenContainerClassName,
          {
            'block max-h-[500rem]': isOpen,
          },
        )}>
        <div
          className={cn(
            'opacity-0 transition-opacity duration-[500ms] ease-in-out',
            {
              'opacity-100': isOpen,
            },
          )}>
          {children}
        </div>
      </div>
    </>
  );
}
